import React from 'react';
import logo from '../lib/assets/img/logo-footer.webp';
import "../styles/Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content" data-testid="footer-content">
        <img src={logo} alt="Company Logo" className="footer-logo" width="289" height="80" decoding="async" />
      </div>
    </footer>
  );
};

Footer.propTypes = {};

export default Footer; 